module.exports = __webpack_public_path__ + "static/media/Tribal Hunter.d8b67e4b.jpg";